/* =====================================================================
   GN CRO/SEO v4 — sitebreed verzendmoment (Europe/Amsterdam)
   Regels George Napoli:
     ma t/m vr + zo, besteld vóór 23:00 → vandaag verzonden (aftellen tot 23:00)
     ma t/m do + zo, ná 23:00           → morgen verzonden
     vr ná 23:00 en za (hele dag)       → zondag verzonden
   Vult:
     [data-gn-delivery-main]  → "Bestel binnen 07:12:45 = vandaag verzonden"
     [data-gn-delivery-short] → "Vandaag verzonden" / "Morgen verzonden" / "Zondag verzonden"
   Ook voor content die later in de DOM komt (cart drawer) via MutationObserver.
   ===================================================================== */
(function () {
  'use strict';

  var DAYS = ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'];
  var CUTOFF_HOUR = 23;

  function amsterdamNow() {
    var f = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Amsterdam',
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false, weekday: 'short'
    });
    var map = {};
    f.formatToParts(new Date()).forEach(function (p) { map[p.type] = p.value; });
    return {
      date: new Date(Date.UTC(+map.year, +map.month - 1, +map.day)),
      hour: (+map.hour) % 24,
      minute: +map.minute,
      second: +map.second,
      weekday: { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 }[map.weekday]
    };
  }
  function addDays(d, n) { var x = new Date(d.getTime()); x.setUTCDate(x.getUTCDate() + n); return x; }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function cap(s) { return s.charAt(0).toUpperCase() + s.slice(1); }

  function shipInfo() {
    var now = amsterdamNow();
    var beforeCutoff = now.hour < CUTOFF_HOUR;

    // Verzenddag: zo t/m vr vóór 23:00 = vandaag; anders eerstvolgende dag die geen zaterdag is
    var ship = now.date;
    if (!(now.weekday !== 6 && beforeCutoff)) {
      ship = addDays(now.date, 1);
      while (ship.getUTCDay() === 6) ship = addDays(ship, 1);
    }
    var diff = Math.round((ship - now.date) / 86400000);

    if (diff === 0) {
      var left = CUTOFF_HOUR * 3600 - (now.hour * 3600 + now.minute * 60 + now.second);
      if (left < 0) left = 0;
      var h = Math.floor(left / 3600), m = Math.floor((left % 3600) / 60), s = left % 60;
      return { today: true, timer: pad(h) + ':' + pad(m) + ':' + pad(s), short: 'Vandaag verzonden' };
    }
    var when = diff === 1 ? 'morgen' : DAYS[ship.getUTCDay()];
    return { today: false, when: when, short: cap(when) + ' verzonden' };
  }

  function render() {
    var info;
    try { info = shipInfo(); } catch (e) { return; }
    var mains = document.querySelectorAll('[data-gn-delivery-main]');
    for (var i = 0; i < mains.length; i++) {
      var el = mains[i];
      if (info.today) {
        var t = el.querySelector('[data-gn-timer]');
        if (!t) {
          el.innerHTML = 'Bestel binnen <span class="gn-timer" data-gn-timer></span> = vandaag verzonden';
          t = el.querySelector('[data-gn-timer]');
        }
        if (t.textContent !== info.timer) t.textContent = info.timer;
      } else {
        var txt = 'Nu besteld = ' + info.when + ' verzonden';
        if (el.textContent !== txt) el.textContent = txt;
      }
    }
    var shorts = document.querySelectorAll('[data-gn-delivery-short]');
    for (var k = 0; k < shorts.length; k++) {
      if (shorts[k].textContent !== info.short) shorts[k].textContent = info.short;
    }
  }

  window.GN = window.GN || {};
  window.GN.renderDelivery = render;
  window.GN.shipInfo = shipInfo;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    render();
    setInterval(render, 1000);

    var pending = null;
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var tg = muts[i].target;
        if (tg && tg.closest && tg.closest('[data-gn-delivery-main],[data-gn-delivery-short]')) continue;
        if (muts[i].addedNodes && muts[i].addedNodes.length) {
          clearTimeout(pending);
          pending = setTimeout(render, 60);
          return;
        }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  });
})();

/* GN 28-09 — productkaarten: prijs + "Vandaag verzonden" per rij op dezelfde hoogte.
   Meet per rij het hoogste titelblok (titel + ondertitel) en geeft de andere dezelfde minimale hoogte.
   Werkt los van de layout (grid, flex, slider) en op alle pagina's met productkaarten. */
(function () {
  'use strict';
  var busy = false, timer = null;
  function textBlock(li) {
    var st = li.querySelector('.static');
    return st && st.previousElementSibling && st.previousElementSibling.tagName !== 'FIGURE' ? st.previousElementSibling : null;
  }
  function run() {
    if (busy) return; busy = true;
    try {
      var lists = document.querySelectorAll('.l4cl:not(.list)');
      for (var l = 0; l < lists.length; l++) {
        var list = lists[l], items = list.children, rows = {}, blocks = [];
        // horizontale slider op mobiel: niet uitlijnen (je ziet ~1 kaart), prijs direct onder de tekst
        var slider = window.innerWidth <= 760 && list.scrollWidth > list.clientWidth + 4;
        for (var i = 0; i < items.length; i++) {
          var li = items[i];
          if (li.tagName !== 'LI' || !li.offsetParent) continue;
          var b = textBlock(li);
          if (!b) continue;
          b.style.minHeight = '';
          if (!slider) blocks.push([li, b]);
        }
        for (var j = 0; j < blocks.length; j++) {
          var top = Math.round(blocks[j][0].getBoundingClientRect().top / 8);
          (rows[top] = rows[top] || []).push(blocks[j][1]);
        }
        for (var k in rows) {
          var row = rows[k], max = 0;
          if (row.length < 2) continue;
          for (var r = 0; r < row.length; r++) max = Math.max(max, row[r].getBoundingClientRect().height);
          for (var s = 0; s < row.length; s++) row[s].style.minHeight = Math.ceil(max) + 'px';
        }
      }
    } catch (e) {}
    busy = false;
  }
  function later() { clearTimeout(timer); timer = setTimeout(run, 120); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  window.addEventListener('load', run);
  window.addEventListener('resize', later);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(run);
  if (window.MutationObserver) {
    new MutationObserver(function (m) {
      for (var i = 0; i < m.length; i++) {
        var t = m[i].target;
        if (m[i].addedNodes.length && t.nodeType === 1 && (t.matches('.l4cl') || t.querySelector('.l4cl'))) { later(); return; }
      }
    }).observe(document.body || document.documentElement, { childList: true, subtree: true });
  }
})();

/* GN 28-09 — snelle "in winkelwagen"-knop (+) rechtsonder op de productfoto.
   Alleen bij producten die op voorraad zijn (kaart toont "Vandaag verzonden").
   1 uitvoering: direct toevoegen en winkelwagen openen. Meerdere: naar de productpagina. */
(function () {
  'use strict';
  var ICON = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>';
  var CHECK = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>';
  function inject() {
    var items = document.querySelectorAll('.l4cl:not(.list) > li');
    for (var i = 0; i < items.length; i++) {
      var li = items[i];
      if (li.querySelector('.gn-qa') || (li.closest && li.closest('#cart'))) continue;
      if (!li.querySelector('.gn-card-delivery')) continue;
      var fig = li.querySelector(':scope > figure'), a = li.querySelector('h3 a[href*="/products/"]');
      if (!fig || !a) continue;
      var name = (li.querySelector('.gn-name') || a).textContent.replace(/\s+/g, ' ').trim();
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'gn-qa';
      b.setAttribute('aria-label', 'Voeg ' + name + ' toe aan winkelwagen');
      b.setAttribute('data-url', a.getAttribute('href').split('?')[0].split('#')[0]);
      b.innerHTML = ICON;
      fig.appendChild(b);
    }
  }
  function openCart() {
    var link = document.querySelector('header a[href$="/cart"], #header a[href$="/cart"], .shopify-section-header a[href$="/cart"]');
    if (link) link.click(); else window.location.href = '/cart';
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.gn-qa');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    if (b.classList.contains('is-loading')) return;
    var url = b.getAttribute('data-url');
    b.classList.add('is-loading');
    fetch(url + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function (p) {
        var avail = (p.variants || []).filter(function (v) { return v.available; });
        if (p.variants.length !== 1 || avail.length !== 1) { window.location.href = url; throw 'nav'; }
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: avail[0].id, quantity: 1 }] })
        });
      })
      .then(function (r) {
        if (!r.ok) throw 0;
        b.classList.remove('is-loading'); b.classList.add('is-added'); b.innerHTML = CHECK;
        openCart();
        setTimeout(function () { b.classList.remove('is-added'); b.innerHTML = ICON; }, 2200);
      })
      .catch(function (err) {
        b.classList.remove('is-loading');
        if (err !== 'nav') window.location.href = url;
      });
  }, true);
  var t = null;
  function later() { clearTimeout(t); t = setTimeout(inject, 150); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', inject); else inject();
  if (window.MutationObserver) {
    new MutationObserver(function (m) {
      for (var i = 0; i < m.length; i++) {
        var n = m[i].target;
        if (m[i].addedNodes.length && n.nodeType === 1 && !(n.closest && n.closest('.gn-qa')) && (n.matches('.l4cl') || n.querySelector('.l4cl'))) { later(); return; }
      }
    }).observe(document.body || document.documentElement, { childList: true, subtree: true });
  }
})();

/* GN 28-09 — "naar boven"-pijltje helemaal weg + headliner mobiel kort en zonder "Read more" */
(function () {
  function hideTop() { var t = document.getElementById('totop'); if (t) t.style.setProperty('display', 'none', 'important'); }
  hideTop();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hideTop);

  var mq = window.matchMedia ? window.matchMedia('(max-width: 760px)') : null;
  function shortUsp() {
    var lis = document.querySelectorAll('#nav-top .l4us > li, .l4us > li');
    for (var i = 0; i < lis.length; i++) {
      var sp = lis[i].querySelector(':scope > span');
      if (!sp) continue;
      if (!sp.hasAttribute('data-gn-full')) {
        if (sp.textContent.indexOf('23:00') === -1) continue;
        sp.setAttribute('data-gn-full', sp.innerHTML);
      }
      var html = sp.getAttribute('data-gn-full');
      if (mq && mq.matches) {
        var info = null;
        try { info = window.GN && window.GN.shipInfo ? window.GN.shipInfo() : null; } catch (e) {}
        html = (!info || info.today) ? '<strong>Vóór 23:00 besteld</strong> = <strong>vandaag verzonden</strong>'
                                     : 'Nu besteld = <strong>' + info.when + ' verzonden</strong>';
      }
      if (sp.innerHTML !== html) sp.innerHTML = html;
    }
  }
  function usp() {
    shortUsp();
    var bar = document.getElementById('nav-top');
    if (!bar) return;
    var txt = ((window.translations && window.translations.readmore_text) || 'Read more').toLowerCase();
    var els = bar.querySelectorAll('a, button, span');
    for (var i = 0; i < els.length; i++) {
      var t = (els[i].textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (t === txt || t === 'read more' || t === 'lees meer') els[i].classList.add('gn-hide-more');
    }
  }
  if (mq) { if (mq.addEventListener) mq.addEventListener('change', shortUsp); else if (mq.addListener) mq.addListener(shortUsp); }
  setInterval(shortUsp, 60000);
  // thema-scripts (o.a. de "Read more"-inkorter) laden later en na interactie: telkens opnieuw toepassen als de balk verandert
  var uspT = null;
  function uspLater() { clearTimeout(uspT); uspT = setTimeout(usp, 40); }
  function watch() {
    var hdr = document.querySelector('.shopify-section-header, #header') || document.body;
    if (!hdr || !window.MutationObserver) return;
    new MutationObserver(function (m) {
      for (var i = 0; i < m.length; i++) {
        var t = m[i].target; if (t && t.nodeType === 3) t = t.parentElement;
        if (t && t.nodeType === 1 && t.closest && t.closest('.l4us, #nav-top')) { uspLater(); return; }
      }
    }).observe(hdr, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
  ['touchstart', 'scroll', 'mousemove'].forEach(function (ev) { window.addEventListener(ev, function () { setTimeout(usp, 600); setTimeout(usp, 2500); }, { passive: true, once: true }); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { usp(); setTimeout(usp, 800); }); else { usp(); setTimeout(usp, 800); }
  window.addEventListener('load', function () { usp(); setTimeout(usp, 1500); });
})();

/* GN 28-09 — collectiepagina: producten vanaf rij 3 vliegen in zodra ze in beeld komen (de eerste 8 doet de CSS bij het laden) */
(function () {
  var body = document.body;
  if (!body || !/\btemplate-collection\b/.test(body.className) || !('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var io = new IntersectionObserver(function (entries) {
    for (var i = 0; i < entries.length; i++) {
      if (entries[i].isIntersecting) { entries[i].target.classList.add('is-in'); io.unobserve(entries[i].target); }
    }
  }, { rootMargin: '0px 0px -6% 0px' });
  function setup() {
    var lis = document.querySelectorAll('#content .l4cl > li:nth-child(n+9):not(.gn-fly)');
    if (!lis.length) return;
    var vh = window.innerHeight, rects = [], i;
    for (i = 0; i < lis.length; i++) rects.push(lis[i].getBoundingClientRect());
    var lastTop = null, col = 0;
    for (i = 0; i < lis.length; i++) {
      var r = rects[i];
      if (!r.height || (r.top < vh && r.bottom > 0)) continue;
      var top = Math.round(r.top / 8);
      if (top !== lastTop) { col = 0; lastTop = top; } else { col++; }
      lis[i].style.setProperty('--gnd', Math.min(col * 0.07, 0.35) + 's');
      lis[i].classList.add('gn-fly');
      io.observe(lis[i]);
    }
  }
  var t = null;
  function later() { clearTimeout(t); t = setTimeout(setup, 120); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup); else setup();
  if (window.MutationObserver) {
    new MutationObserver(function (m) {
      for (var i = 0; i < m.length; i++) { if (m[i].addedNodes.length && m[i].target.nodeType === 1 && m[i].target.closest && m[i].target.closest('#content')) { later(); return; } }
    }).observe(document.getElementById('content') || body, { childList: true, subtree: true });
  }
})();

/* GN 28-09 — productpagina: bij bundel en cadeau ook het basisproduct tonen; stapelkorting 1/2/3 afbeeldingen */
(function () {
  function base() {
    var s = document.querySelector('.gn-sticky__img');
    if (s && s.getAttribute('src')) return { src: s.getAttribute('src'), srcset: s.getAttribute('srcset') };
    var m = document.querySelector('meta[property="og:image"]');
    return m && m.content ? { src: m.content } : null;
  }
  function img(b, cls) {
    var i = document.createElement('img');
    if (cls) i.className = cls;
    i.src = b.src; if (b.srcset) i.srcset = b.srcset;
    i.alt = ''; i.width = 56; i.height = 56; i.decoding = 'async';
    return i;
  }
  function run() {
    var b = base();
    if (!b) return;
    var sets = [['.gn-combo__option--bundle > .gn-combo__image-circle', 'gn-combo__image'], ['.gn-gift__option--gift > .gn-gift__image-circle', 'gn-gift__image']];
    for (var s = 0; s < sets.length; s++) {
      var els = document.querySelectorAll(sets[s][0]);
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        var wrap = document.createElement('div');
        wrap.className = 'gn-pair';
        el.parentNode.insertBefore(wrap, el);
        var c = document.createElement('div');
        c.className = el.className + ' gn-pair__base';
        c.appendChild(img(b, sets[s][1]));
        var plus = document.createElement('span');
        plus.className = 'gn-pair__plus'; plus.setAttribute('aria-hidden', 'true'); plus.textContent = '+';
        wrap.appendChild(c); wrap.appendChild(el); wrap.appendChild(plus);
        el.classList.add('gn-pair__add');
      }
    }
    var opts = document.querySelectorAll('.gn-stack__option');
    for (var k = 0; k < opts.length; k++) {
      var o = opts[k];
      if (o.querySelector('.gn-stack__thumbs')) continue;
      var inp = o.querySelector('input[data-gn-qty]');
      var n = Math.max(1, Math.min(3, parseInt(inp && inp.getAttribute('data-gn-qty'), 10) || 1));
      var th = document.createElement('span');
      th.className = 'gn-stack__thumbs'; th.setAttribute('aria-hidden', 'true');
      for (var q = 0; q < n; q++) { var d = document.createElement('span'); d.className = 'gn-stack__thumb'; d.appendChild(img(b)); th.appendChild(d); }
      o.insertBefore(th, o.querySelector('.gn-stack__info'));
    }
  }
  function txt(el) { return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : ''; }
  function cap(s) { return s.charAt(0).toUpperCase() + s.slice(1); }
  function money(el) { var m = txt(el).match(/€\s?[\d.,]+/); return m ? m[0] : ''; }
  function tidy() {
    var i, o, name, sav, t, m, amt, pct;
    var combos = document.querySelectorAll('.gn-combo__option--bundle');
    for (i = 0; i < combos.length; i++) {
      o = combos[i];
      if (o.getAttribute('data-gn-tidy')) continue;
      o.setAttribute('data-gn-tidy', '1');
      name = o.querySelector('.gn-combo__name'); sav = o.querySelector('.gn-combo__saving');
      t = txt(name); amt = money(sav);
      m = t.match(/^Voeg (?:een |de |het )?(.+?) toe met (\d+)% korting$/i);
      if (m) { name.textContent = '+ ' + cap(m[1]); if (sav) sav.textContent = '−' + m[2] + '% · bespaar ' + amt; }
      else if ((m = t.match(/^Combineer met (?:een |de |het )?(.+?) en ontvang (\d+)% korting/i))) {
        name.textContent = '+ ' + cap(m[1]); if (sav) sav.textContent = '−' + m[2] + '% op dit product · bespaar ' + amt;
      } else if ((m = t.match(/(\d+)% korting/))) {
        var pt = txt(o.querySelector('.gn-combo__product-title'));
        if (pt) name.textContent = '+ ' + pt.replace(/^George Napoli\s+/i, '');
        if (sav) sav.textContent = '−' + m[1] + '% · bespaar ' + amt;
      }
      var ex = o.querySelector('.gn-combo__extra-price');
      if (ex) ex.textContent = txt(ex).replace(/^Slechts\s*/i, '');
    }
    var gifts = document.querySelectorAll('.gn-gift__option--gift');
    for (i = 0; i < gifts.length; i++) {
      o = gifts[i];
      if (o.getAttribute('data-gn-tidy')) continue;
      o.setAttribute('data-gn-tidy', '1');
      name = o.querySelector('.gn-gift__name--gift') || o.querySelector('.gn-gift__name');
      t = txt(name);
      m = t.match(/^Ontvang tijdelijk (?:een |de |het )?(.+?) cadeau$/i);
      if (name) name.textContent = '+ ' + (m && m[1] && !/^cadeau$/i.test(m[1]) ? cap(m[1]) + ' cadeau' : 'Gratis cadeau');
      var cond = o.querySelector('.gn-gift__condition'), val = money(o.querySelector('.gn-gift__value-corner'));
      if (cond) cond.textContent = 'Gratis' + (val ? ' · t.w.v. ' + val : '');
    }
    var disc = document.querySelectorAll('.gn-stack__discount');
    for (i = 0; i < disc.length; i++) {
      pct = txt(disc[i]).match(/(\d+)\s*%/);
      if (pct) disc[i].textContent = '−' + pct[1] + '%';
    }
    var boxes = document.querySelectorAll('.gn-combo, .gn-gift, .gn-stack');
    for (i = 0; i < boxes.length; i++) boxes[i].classList.add('gn-tidy');
  }
  function all() { try { run(); } catch (e) {} try { tidy(); } catch (e) {} }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
})();
